module.exports = __webpack_public_path__ + "img/about-3.cd71512c.jpg";